import { render, staticRenderFns } from "./MyOrdersPatentHostingRepresentative.vue?vue&type=template&id=2bba57af"
import script from "./MyOrdersPatentHostingRepresentative.vue?vue&type=script&lang=js"
export * from "./MyOrdersPatentHostingRepresentative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports